<template>
  <div>
    <base-select
      title="دسترسی باربری ها"
      placeholder="انتخاب دسترسی باربری ها"
      :float-title="true"
      :search_able="true"
      :search_in_front="true"
      :multiple="true"
      :loading="loadingGetFreightages"
      v-model="freightages_ids"
      :options="freightages"
      :show-alert="!factory_id && 'ابتدا کارخانه را انتخاب کنید'"
      :error-message="errorMessage"
      icon="person"
    />
  </div>
</template>

<script setup>
import BaseSelect from '@/components/base/select/BaseSelect.vue'
import { watch, ref, defineProps, defineEmits } from 'vue'
import { apiGetFreightages } from '@/services/Freightage'

const loadingGetFreightages = ref(false)
const freightages_ids = ref([])
const freightages = ref([])

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  errorMessage: {
    type: String,
    default: null,
  },
  factory_id: {
    type: [Number, String],
    default: null,
  },
})

async function getFreightages() {
  if (!props.factory_id) return

  freightages_ids.value = []
  loadingGetFreightages.value = true
  freightages.value = []

  try {
    const response = await apiGetFreightages({ factory_id: props.factory_id })

    if (!response) return
    freightages.value = response?.data?.freightages
  } catch (error) {
    console.log(error)
  } finally {
    loadingGetFreightages.value = false
  }
}

watch(
  () => props.factory_id,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      getFreightages()
    }
  },
  { immediate: true },
)

watch(
  () => freightages_ids.value,
  (newValue) => {
    const allSelected =
      freightages.value.length > 0 &&
      newValue.length === freightages.value.length

    emit('update:modelValue', allSelected ? ['all'] : newValue)
  },
  { deep: true },
)
</script>

<style scoped></style>
